import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { GridDataView } from "./views/grid-data-view";
import { LoginView } from "./views/login-view";

import { ProtectedRoute } from "./components/protected-route";
import RegisterForm from "./views/RegisterForm";
import Terminal from "./views/terminal";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginView />} />
        <Route path="/terminal" element={<Terminal />} />
        <Route path="/home" element={
          <ProtectedRoute>
            <Terminal />
          </ProtectedRoute>
        } />
        <Route path="/grid" element={
          <ProtectedRoute>
            <GridDataView />
          </ProtectedRoute>
        } />
        <Route path="/market" element={
          <ProtectedRoute>
            <GridDataView />
          </ProtectedRoute>
        } />
        <Route path="/research" element={
          <ProtectedRoute>
            <GridDataView />
          </ProtectedRoute>
        } />


        <Route path="/register" element={
          < RegisterForm />
        } />
      </Routes>
    </Router>
  );
}

export default App;